import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance } from 'vue'
import FleetColor from '@/components/fleet/FleetColor.vue'
import { buildFleetUIStateId, FleetUiState } from '@/models/ui/FleetUiState'
import MissionLine from '@/components/mission/MissionLine.vue'
import { buildMissionUIStateId as buildMissionUIStateIdUtil } from '@/models/ui/MissionUiState'
import { AloMission } from '@/models/alo/AloMission'
import FleetTimeLine from '@/components/fleet/FleetTimeLine.vue'
import FleetState from '@/components/fleet/FleetState.vue'
import store from '@/store'
import { i18n } from '@/locale/vueI18n'
import { isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import { VuetifyConfirmObject } from 'vuetify-confirm/types'

// Accès aux plugins Vue via l'instance (Vue 2 + Composition API)

export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDrawerInformation',
  setup(__props) {

const instance = getCurrentInstance()
const $confirm = instance?.proxy?.$confirm!

const sending = ref(false)

const height = ref(0)

const currentDetailFleet = computed(() => store.myGetters.currentDetailFleet)

const fleet = computed(() => currentDetailFleet.value && currentDetailFleet.value.fleet)

const fleetIco = computed(() => {
  return isAloDbFleetCoverage(fleet.value)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(fleet.value)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const fleet_state = computed(() => fleet.value?.config?.fleet_state)
const fleet_state_timestamp = computed(() => fleet.value?.config?.fleet_state_timestamp)

async function sendCommand(command: string) {
  $confirm(i18n.t('Fleet.ConfirmCommand', { command }).toString(), {
    title: i18n.t('Fleet.Command'),
    buttonTrueText: i18n.t('Global.Ok'),
    buttonFalseText: i18n.t('Global.Cancel'),
  } as VuetifyConfirmObject).then(async confirmed => {
    if (confirmed) {
      sending.value = true
      await store.myActions.ADMINFLEET_SEND_COMMAND_IRIS_REQUEST(command)
      sending.value = false
    }
  })
}

async function sendStopCommand() {
  $confirm(i18n.t('Fleet.ConfirmStopCommand', { command: 'STOP' }).toString(), {
    title: i18n.t('Fleet.Command'),
    color: 'error',
    buttonTrueText: i18n.t('Global.Ok'),
    buttonFalseText: i18n.t('Global.Cancel'),
  } as VuetifyConfirmObject).then(async confirmed => {
    if (confirmed) {
      sending.value = true
      await store.myActions.ADMINFLEET_SEND_COMMAND_IRIS_REQUEST('STOP')
      sending.value = false
    }
  })
}

const missions = computed(() => {
  return fleet.value?.param?.missionIds?.map(id => store.myGetters.missionsById[id]).filter(m => !!m) ?? []
})

const fleet_uiid = computed(() => {
  return buildFleetUIStateId(currentDetailFleet.value.fleet.FLE_ID!, 'detail')
})

// recupere le state de travail
const fleetState = computed(() => {
  // retourne un FleetUiState
  return store.myGetters.fleetUiStateByUiid(fleet_uiid.value)
})

function zoomOnMap() {
  store.myActions.UI_SELECT_FLEET_MAP({ id: fleet.value.FLE_ID!, uiid: '' })
}
function buildMissionUIStateId(missionId: number, suffixe: string) {
  return buildMissionUIStateIdUtil(missionId, suffixe)
}

function showInfos() {
  if (!fleetState.value.infosPanelVisible) {
    store.myActions.UI_TOGGLE_MISSION_INFO_PANEL_VISIBILITY(fleet_uiid.value)
  }
}

function onResize() {
  // Handle resize if needed
}

return { __sfc: true,instance, $confirm, sending, height, currentDetailFleet, fleet, fleetIco, fleet_state, fleet_state_timestamp, sendCommand, sendStopCommand, missions, fleet_uiid, fleetState, zoomOnMap, buildMissionUIStateId, showInfos, onResize, FleetColor, MissionLine, FleetTimeLine, FleetState, isAloDbFleetCoverage }
}

})